export const PAYMENT_URL =
  "https://superprofile.bio/vp/your-payment-page-title-here-963-964?checkout=true";
export const WHATSAPP_URL = "https://wa.me/919762342196";
export const WHATSAPP_NUMBER = "+91 97623 42196";

export const VIDEO_EMBED_URL = "https://www.youtube.com/embed/UndUAeII4_o?autoplay=1&rel=0";
export const VIDEO_POSTER = "https://i.ytimg.com/vi/UndUAeII4_o/maxresdefault.jpg";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1785245560617-d1ece651e966?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwcHJvZHVjdCUyMHdvcmtzcGFjZSUyMG1pbmltYWx8ZW58MHx8fHwxNzkyMDk3NDM0fDA&ixlib=rb-4.1.0&q=85";
export const VIDEO_THUMB =
  "https://images.unsplash.com/photo-1741466071751-c62474d2d3ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxjcmVhdG9yJTIwZGVzayUyMGxhcHRvcCUyMHN0dWRpb3xlbnwwfHx8fDE3OTIwOTc0MzN8MA&ixlib=rb-4.1.0&q=85";
export const DARK_TEXTURE =
  "https://images.unsplash.com/photo-1665652475985-37e285aeff53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjBwdXJwbGUlMjBnZW9tZXRyaWN8ZW58MHx8fHwxNzkyMDk3NDM4fDA&ixlib=rb-4.1.0&q=85";

// Real screenshots uploaded by the site owner — captions only describe what is visible.
export const PROOF_IMAGES = [
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_ec0c9d35-779d-4a07-b481-5ca9354ee425/artifacts/b996d8d7cb1b1485_IMG_0701.webp",
    caption: "Razorpay payment confirmation",
    date: "1 May",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_ec0c9d35-779d-4a07-b481-5ca9354ee425/artifacts/1e1e27f5116ef32b_IMG_2209.webp",
    caption: "SuperProfile daily earnings",
    date: "4 Oct",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_ec0c9d35-779d-4a07-b481-5ca9354ee425/artifacts/c3b277a4baadb41f_IMG_0699.webp",
    caption: "Razorpay payment confirmations",
    date: "24 Apr",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_ec0c9d35-779d-4a07-b481-5ca9354ee425/artifacts/9a35f0efe52a896f_IMG_2148.webp",
    caption: "SuperProfile weekly earnings",
    date: "30 Sep – 4 Oct",
  },
  {
    src: "https://customer-assets-agu9un31.emergentagent.net/job_ec0c9d35-779d-4a07-b481-5ca9354ee425/artifacts/4f1e3ede96752afa_IMG_0697.webp",
    caption: "SuperProfile sale notification",
    date: "",
  },
];

export const NAV_LINKS = [
  { label: "Overview", hash: "#overview" },
  { label: "Curriculum", hash: "#curriculum" },
  { label: "Income Proof", hash: "#proof" },
  { label: "Instructor", hash: "#instructor" },
  { label: "FAQs", hash: "#faq" },
];

export const scrollToHash = (e, hash, onDone) => {
  e.preventDefault();
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
  if (onDone) onDone();
};
